// App.jsxAdd commentMore actions
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { loadMasterData } from "./core/redux/action";
import AllRoutes from "./Router/router";
import { useLocation } from "react-router-dom";

export default function App() {
    const location = useLocation();
    const publicRoutes = ["/","/sign-in","/signup","/forgot-password"];
    const dispatch = useDispatch();
    // useEffect(() => {
    //     debugger
    //     if (publicRoutes.includes(location.pathname)) return;
    //     dispatch(loadMasterData());
    // }, []);
    useEffect(() => {
        if (localStorage.getItem("permissions")) {
            dispatch(loadMasterData());
        }
    }, []);
    
    return <AllRoutes />;
}
